import React, { useState } from "react";
import { DatePicker } from "rsuite";
import moment from "moment";
import "./BookTrialSessionTable.scss";
import { useEffect } from "react";
import freeSlots from "service/user/csm/sessions/get-free-slots";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import CustomSelect from "components/Select/Select";
import JennyFace from "assets/imgs/icons/JennyFace.svg";
import { useRef } from "react";
import { Overlay } from "react-bootstrap";

function BookTrialSessionTable({
  date,
  setDate,
  slots,
  setWeekCount,
  setFetchFreeSlots,
  selectedTutor,
  selSessions,
  setSelSessions,
  sessionStatus,
  timeZone,
  data,
  setData,
  stepGuide,
  setStepGuide,
}) {
  const [dates, setDates] = useState({
    sun: "",
    mon: "",
    tue: "",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
  });
  const target = useRef(null);
  const [showToolTipBook, setShowToolTipBook] = useState(false);

  const selectSchedulePopover = (
    <Popover id="popover-basic" className="popover-initial">
      <Popover.Header as="h3"></Popover.Header>
      <Popover.Body className="d-flex">
        <img src={JennyFace} alt="Jenny" className="avatar-img" />
        <span>
          Book your first trial class by choosing your preferred time slot and
          Date
        </span>
      </Popover.Body>
    </Popover>
  );

  const nextDay = (num) => {
    let startDate = moment(date).startOf("week").toDate();
    let nextDay = new Date(startDate);
    nextDay.setDate(startDate.getDate() + num);
    return nextDay.getDate();
  };

  const setWeekDates = () => {
    setDates(() => {
      return {
        sun: nextDay(0),
        mon: nextDay(1),
        tue: nextDay(2),
        wed: nextDay(3),
        thu: nextDay(4),
        fri: nextDay(5),
        sat: nextDay(6),
      };
    });
  };

  const updateWeekCount = () => {
    let now = new Date(date);
    const onejan = new Date(now.getFullYear(), 0, 1);
    const week = Math.ceil(
      ((now.getTime() - onejan.getTime()) / 86400000 + onejan.getDay() + 1) / 7
    );
    setWeekCount(week);
    if (selectedTutor?.teacherId) {
      setFetchFreeSlots(true);
    }
  };

  const currentDay = (d) => {
    if (new Date(moment(date).format("MM-DD-yyyy")).getDate() === d) {
      return `current-day`;
    }
  };

  const checkDate = (s) => {
    let newd = new Date(moment(s.date).format("MM-DD-yyyy"));
    let curD = new Date();
    if (moment(newd).format("MM-DD-yyyy") < moment(curD).format("MM-DD-yyyy")) {
      return true;
    }
    return false;
  };

  const checkDecrement = () => {
    let newd = new Date(moment(date).format("MM-DD-yyyy"));
    let curD = new Date();
    // console.log(moment(newd).format("MM-DD-yyyy"));
    // console.log(moment(curD).format("MM-DD-yyyy"));
    if (
      moment(newd).format("MM-DD-yyyy") === moment(curD).format("MM-DD-yyyy")
    ) {
      return true;
    }
    return false;
  };

  const checkIfSelected = (s) => {
    let temp = [...selSessions];
    if (
      temp.filter((ses) => {
        if (
          ses.dayOfTheWeek === s.dayOfTheWeek &&
          ses.startTime === s.startTime
        )
          return ses;
      }).length > 0
    )
      return true;
    else return false;
  };

  const handleClick = (s) => {
    if (checkDate(s)) {
      return;
    }
    if (stepGuide == 6) {
      setStepGuide((prev) => prev + 1);
    }
    let temp = [...selSessions];
    if (!sessionStatus?.returnFlag) {
      temp = [s];
    } else {
      if (checkIfSelected(s)) {
        console.log();
        temp = temp.filter((ses) => {
          if (
            ses.dayOfTheWeek !== s.dayOfTheWeek ||
            ses.startTime !== s.startTime
          )
            return ses;
        });
      } else {
        temp.push(s);
      }
    }
    // console.log(temp);
    setSelSessions(temp);
  };

  const handleIncrement = () => {
    setDate(() => {
      let newd = new Date(moment(date).format("MM-DD-yyyy"));
      let next = new Date(
        newd.getFullYear(),
        newd.getMonth(),
        newd.getDate() + 7
      );
      // console.log(moment(next).format("MM-DD-yyyy"));
      return moment(next).format("DD-MMM-yyyy");
    });
  };
  const handleDecrement = () => {
    setDate(() => {
      let newd = new Date(moment(date).format("MM-DD-yyyy"));
      let next = new Date(
        newd.getFullYear(),
        newd.getMonth(),
        newd.getDate() - 7
      );
      return moment(next).format("DD-MMM-yyyy");
    });
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h5" className="my-0">
        The timings shown below are in {timeZone}
      </Popover.Header>
      <Popover.Body className="popover-body">
        <CustomSelect
          labelClass="cif__text_primary d-none"
          type="ternery"
          value={data.timeZone.selected}
          options={data.timeZone.options}
          // loading={queries[0].isFetching}
          // key={data.siblings.selected}
          onChange={(selected) => {
            // console.log(selected);
            setData((prev) => {
              return {
                ...prev,
                timeZone: {
                  ...prev.timeZone,
                  selected: selected,
                },
              };
            });
            if (selectedTutor?.teacherId) {
              setFetchFreeSlots(true);
            }
          }}
        />
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    setWeekDates();
    updateWeekCount();
  }, [date]);

  useEffect(() => {
    if (stepGuide == 6) {
      setShowToolTipBook(true);
    } else if (stepGuide == 7) {
      setShowToolTipBook(false);
    }
  }, [stepGuide]);

  return (
    <div className="table-container">
      <div className="row">
        <div className="col-md-3 col-sm-12">
          <DatePicker
            block
            oneTap={true}
            size="lg"
            format="dd-MMM-yyyy"
            className="date-input-csm"
            minDate={moment().toDate()}
            cleanable={false}
            onChange={(date) => {
              let newd = new Date(moment(date).format("MM-DD-yyyy"));
              let curD = new Date();
              // console.log(moment(newd).format("MM-DD-yyyy"));
              // console.log(moment(curD).format("MM-DD-yyyy"));
              if (
                moment(newd).format("MM-DD-yyyy") >=
                  moment(curD).format("MM-DD-yyyy") &&
                newd.getFullYear() >= curD.getFullYear()
              ) {
                setDate(moment(date).format("DD-MMM-yyyy"));
              }

              // console.log(moment(date).format("DD-MMM-yyyy"));
            }}
            value={new Date(moment(date).format("MM-DD-YYYY"))}
            placeholder={date}
          />
        </div>
        <div className="col-md-9 col-sm-12 d-flex justify-content-end fwd-bkd-button-container">
          <div className="timezone-container">
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
              <button>&#33;</button>
            </OverlayTrigger>
            <p>The Timings shown below are in {timeZone}</p>
          </div>
          <button
            disabled={checkDecrement() ? true : false}
            className={`${checkDecrement() ? "disabled" : null}`}
            onClick={() => {
              handleDecrement();
            }}
          >
            {"<"}
          </button>
          <button
            onClick={() => {
              handleIncrement();
            }}
          >
            {">"}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <table className="session-table" ref={target}>
            <thead>
              <tr>
                <td>
                  <div className={currentDay(dates.sun)}>
                    <p>Sun</p>
                    <p>{dates.sun}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.mon)}>
                    <p>Mon</p>
                    <p>{dates.mon}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.tue)}>
                    <p>Tue</p>
                    <p>{dates.tue}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.wed)}>
                    <p>Wed</p>
                    <p>{dates.wed}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.thu)}>
                    <p>Thu</p>
                    <p>{dates.thu}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.fri)}>
                    <p>Fri</p>
                    <p>{dates.fri}</p>
                  </div>
                </td>
                <td>
                  <div className={currentDay(dates.sat)}>
                    <p>Sat</p>
                    <p>{dates.sat}</p>
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              {slots === null ? (
                <tr>
                  <td colSpan={7} className="py-4">
                    No Sessions Available
                  </td>
                </tr>
              ) : (
                <tr>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 0) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 1) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 2) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 3) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 4) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 5) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                  <td>
                    {slots?.map((s, i) => {
                      if (s.dayOfTheWeekCount === 6) {
                        return (
                          <p
                            key={i}
                            className={`${
                              !sessionStatus?.returnFlag
                                ? selSessions.includes(s)
                                  ? "selected"
                                  : null
                                : checkIfSelected(s)
                                ? "selected"
                                : null
                            } ${checkDate(s) ? "disabled" : null}`}
                            onClick={() => handleClick(s)}
                          >
                            {s.startTime}
                          </p>
                        );
                      }
                    })}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Overlay
            target={target.current}
            show={showToolTipBook}
            placement="top"
          >
            {selectSchedulePopover}
          </Overlay>
        </div>
      </div>
    </div>
  );
}

export default BookTrialSessionTable;
